import { store } from "@/main";

export default class UploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.keyServies = store.state.fileManagement.resource;
    this.keyValue = store.state.fileManagement.resource_id;
  }

  // Starts the upload process.
  upload() {
    // store.commit()
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          //   const reader = new FileReader();

          if (file.size < 500001) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            return (reader.onloadend = () => {
              resolve({
                default: reader.result,
              });
            });
          } else {
            alert("حجم فایل مورد  قبول حداکثر 500 کیلوبایت می‌باشد");
            reject();
          }
        })
    );
  }

  // Aborts the upload process.
  abort() {
    // if ( this.xhr ) {
    //   this.xhr.abort();
    // }
  }

  // Initializes the XMLHttpRequest object using the URL passed to the constructor.
  _initRequest() {
    // const xhr = this.xhr = new XMLHttpRequest();
    //
    // xhr.open( 'POST', '<url here>', true );
    // xhr.responseType = 'json';
  }

  // Initializes XMLHttpRequest listeners.
  _initListeners(resolve, reject, file) {
    // const xhr = this.xhr;
    // const loader = this.loader;
    // const genericErrorText = `Couldn't upload file: ${ file.name }.`;
    //
    // xhr.addEventListener( 'error', () => reject( genericErrorText ) );
    // xhr.addEventListener( 'abort', () => reject() );
    // xhr.addEventListener( 'load', () => {
    //   const response = xhr.response;
    //
    //   if ( !response || response.error ) {
    //     return reject( response && response.error ? response.error.message : genericErrorText );
    //   }
    //
    //   resolve( {
    //     default: response.url
    //   } );
    // } );
    //
    // if ( xhr.upload ) {
    //   xhr.upload.addEventListener( 'progress', evt => {
    //     if ( evt.lengthComputable ) {
    //       loader.uploadTotal = evt.total;
    //       loader.uploaded = evt.loaded;
    //     }
    //   } );
    // }
  }

  // Prepares the data and sends the request.
  _sendRequest(file) {
    // // Prepare the form data.
    // const data = new FormData();
    //
    // data.append( 'upload', file );
    //
    // // Send the request.
    // this.xhr.send( data );
    try {
      // let keyServies = this.keyServies
      // let keyValue = this.keyValue
      let formData = new FormData();
      formData.append("image", this.file);
      const response = this.attachmentTempRepository
        .create(
          formData,
          {
            "Content-Type": "multipart/form-data",
          },
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        )
        .then((response) => {})
        .catch((err) => {});

      let responseCode = {
        code: response.data.data.code,
        name: response.data.data.name,
        type: response.data.data.type,
      };
      this.$notify.success(response.data.message);
      this.$emit("saveAttachmentTemp", responseCode);
    } catch (error) {
      this.$generateError(error);
    }
  }
}
